import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';

// components
import { Button, Card, CardBody, CardHeader, Row, Col, Spinner, FormGroup, Form, Input } from "reactstrap";
import Select from 'react-select';
import MaterialTable from 'material-table';

// style
import { table_translate, table_style } from "../../../constants/MaterialTable.js";

// api
import grupofde_api from "../../../api/grupofde_api.js";
import contrato_api from "../../../api/contrato_api.js";

// helpers
import { showMessage, showQuestion } from "../../../helpers/message.js";

const options_status = [
    { label: "Ativo", value: "Ativo" },
    { label: "Inativo", value: "Inativo" }
];

const options_recorrencia = [
    { label: "Mensal", value: "Mensal" },
    { label: "Bimestral", value: "Bimestral" },
    { label: "Trimestral", value: "Trimestral" },
    { label: "Quadrimestral", value: "Quadrimestral" },
    { label: "Semestral", value: "Semestral" },
    { label: "Anual", value: "Anual" }
];

export default function GrupoFDEFicha({ item, handleReturn }) {
    const { register, errors, handleSubmit, setValue, clearErrors } = useForm({ mode: "onBlur" });
    const [showLoading, setshowLoading] = useState(false);

    const [grupo, set_grupo] = useState(item);

    const [status, set_status] = useState("Ativo");
    const handleChangeStatus = (value) => {
        set_status(value);
        clearErrors("status");
        setValue("status", value, true);
    }

    const [recorrencia, set_recorrencia] = useState("Mensal");
    const handleChangeRecorrencia = (value) => {
        set_recorrencia(value);
        clearErrors("recorrencia");
        setValue("recorrencia", value, true);
    }

    // Contratos do grupo (ponderação)
    const [contratos, set_contratos] = useState([]);
    const [options_contratos, set_options_contratos] = useState([]);
    const [contratoSelecionado, set_contratoSelecionado] = useState(null);
    const [ponderacao, set_ponderacao] = useState("");

    const loadContratosVigentes = () => {
        contrato_api.getAllVigentes().then(result => {
            if (result.status === 200) {
                set_options_contratos(result.data);
            }
        });
    }

    const somaPonderacoes = contratos.reduce((soma, c) => soma + Number(c.ponderacao || 0), 0);

    const handleAdicionarContrato = () => {
        if (!contratoSelecionado || !ponderacao) {
            showMessage("Aviso", "Selecione um contrato e informe a ponderação.", 'warning', null);
            return;
        }

        const ponderacaoNum = Number(ponderacao);
        if (isNaN(ponderacaoNum) || ponderacaoNum < 0 || ponderacaoNum > 100) {
            showMessage("Aviso", "A ponderação deve estar entre 0 e 100.", 'warning', null);
            return;
        }

        const jaExiste = contratos.some(c => c.contrato_Id === contratoSelecionado.contrato_Id);
        if (jaExiste) {
            set_contratos(contratos.map(c => c.contrato_Id === contratoSelecionado.contrato_Id
                ? { ...c, ponderacao: Number(ponderacao) }
                : c));
        } else {
            set_contratos([...contratos, {
                contrato_Id: contratoSelecionado.contrato_Id,
                contratoIdentificacao: contratoSelecionado.identificacao,
                ponderacao: Number(ponderacao)
            }]);
        }

        set_contratoSelecionado(null);
        set_ponderacao("");
    }

    const handleEditarPonderacao = (rowData) => {
        set_contratoSelecionado({ contrato_Id: rowData.contrato_Id, identificacao: rowData.contratoIdentificacao });
        set_ponderacao(rowData.ponderacao);
    }

    const handleRemoverContrato = (rowData) => {
        showQuestion("Atenção", "Tem certeza que quer remover esse contrato do grupo?", "question", function (confirmado) {
            if (!confirmado) return;
            set_contratos(contratos.filter(c => c.contrato_Id !== rowData.contrato_Id));
        });
    }

    const loadForm = () => {
        if (grupo) {
            setValue("identificacao", grupo.identificacao);
            set_status(grupo.status);
            setValue("status", grupo.status, true);
            set_recorrencia(grupo.recorrencia);
            setValue("recorrencia", grupo.recorrencia, true);
            setValue("proximoProcessamento", grupo.proximoProcessamento ? grupo.proximoProcessamento.split("T")[0] : "");
            set_contratos((grupo.contratos || []).map(c => ({
                contrato_Id: c.contrato_Id,
                contratoIdentificacao: c.contratoIdentificacao,
                ponderacao: c.ponderacao
            })));
        } else {
            setValue("status", "Ativo", true);
            setValue("recorrencia", "Mensal", true);
        }
    }

    useEffect(() => {
        loadContratosVigentes();
        loadForm();
    }, []);

    const Voltar = () => {
        handleReturn();
    }

    const onSubmit = (data) => {
        if (somaPonderacoes !== 100 && contratos.length > 0) {
            showMessage("Aviso", `A soma das ponderações está em ${somaPonderacoes}%, mas deveria ser 100%. Corrija antes de salvar.`, 'warning', null);
            return;
        }

        let json_submit = {
            grupoFDE_Id: grupo ? grupo.grupoFDE_Id : 0,
            identificacao: data.identificacao,
            status: status,
            recorrencia: recorrencia,
            proximoProcessamento: data.proximoProcessamento || null,
            contratos: contratos.map(c => ({ contrato_Id: c.contrato_Id, ponderacao: c.ponderacao }))
        };

        setshowLoading(true);
        if (json_submit.grupoFDE_Id === 0)
            grupofde_api.postGrupo(json_submit).then(result => handleReturnSubmit(result));
        else
            grupofde_api.putGrupo(json_submit).then(result => handleReturnSubmit(result));
    }

    const handleReturnSubmit = (result) => {
        setshowLoading(false);
        if (result.status !== 200) {
            showMessage("Aviso", result.message, 'error', null);
        }
        else {
            showMessage("Aviso", "Operação executada com sucesso!", 'success', function () {
                handleReturn();
            });
        }
    }

    return (
        <>
            {showLoading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <Spinner></Spinner>
                    </div>
                </div>
            }
            <div className="content">
                <Row>
                    <Col md="6">
                        <Button color="default" onClick={Voltar}><i className="fas fa-chevron-left"></i>  Voltar</Button>
                    </Col>
                    <Col md="12">
                        <Card>
                            <CardHeader>
                                <h4 className="titleCard">{grupo ? "Editar Grupo FDE" : "Novo Grupo FDE"}</h4>
                            </CardHeader>
                            <CardBody>
                                <Form onSubmit={handleSubmit(onSubmit)}>
                                    <Row className="align-items-end">
                                        <Col lg="6" md="12" sm="12">
                                            <FormGroup>
                                                <label className="form-control-label">Identificação</label>
                                                <Input className="form-control"
                                                    autoComplete="off"
                                                    type="text"
                                                    name="identificacao"
                                                    innerRef={register({ required: true })}
                                                    maxLength={200}
                                                />
                                                {errors.identificacao && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col lg="3" md="6" sm="12">
                                            <FormGroup>
                                                <label className="form-control-label">Recorrência</label>
                                                <Select
                                                    name="recorrencia"
                                                    options={options_recorrencia}
                                                    getOptionLabel={o => o.label}
                                                    getOptionValue={o => o.value}
                                                    value={options_recorrencia.filter(f => f.value === recorrencia)}
                                                    onChange={(o) => handleChangeRecorrencia(o.value)}
                                                    classNamePrefix="select"
                                                    placeholder="[ Selecione ]"
                                                    ref={e => register(
                                                        { name: "recorrencia" },
                                                        { required: true })
                                                    }
                                                />
                                                {errors.recorrencia && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col lg="3" md="6" sm="12">
                                            <FormGroup>
                                                <label className="form-control-label">Status</label>
                                                <Select
                                                    name="status"
                                                    options={options_status}
                                                    getOptionLabel={o => o.label}
                                                    getOptionValue={o => o.value}
                                                    value={options_status.filter(f => f.value === status)}
                                                    onChange={(o) => handleChangeStatus(o.value)}
                                                    classNamePrefix="select"
                                                    placeholder="[ Selecione ]"
                                                    ref={e => register(
                                                        { name: "status" },
                                                        { required: true })
                                                    }
                                                />
                                                {errors.status && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col lg="4" md="6" sm="12">
                                            <FormGroup>
                                                <label className="form-control-label">Próximo Processamento</label>
                                                <Input className="form-control"
                                                    autoComplete="off"
                                                    type="date"
                                                    name="proximoProcessamento"
                                                    innerRef={register()}
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>

                                    <hr />
                                    <h5>Contratos do Grupo</h5>
                                    <Row className="align-items-end">
                                        <Col lg="6" md="12" sm="12">
                                            <FormGroup>
                                                <label className="form-control-label">Contrato</label>
                                                <Select
                                                    options={options_contratos}
                                                    getOptionLabel={o => o.identificacao}
                                                    getOptionValue={o => o.contrato_Id}
                                                    value={contratoSelecionado}
                                                    onChange={(o) => set_contratoSelecionado(o)}
                                                    classNamePrefix="select"
                                                    placeholder="[ Buscar contrato ]"
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col lg="3" md="6" sm="12">
                                            <FormGroup>
                                                <label className="form-control-label">Ponderação (%)</label>
                                                <Input className="form-control"
                                                    type="number"
                                                    min="0"
                                                    max="100"
                                                    value={ponderacao}
                                                    onChange={(e) => set_ponderacao(e.target.value)}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col lg="3" md="6" sm="12">
                                            <Button color="default" type="button" onClick={handleAdicionarContrato}>
                                                <i className="fa fa-plus"></i>  Adicionar
                                            </Button>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg="12" md="12" sm="12">
                                            <MaterialTable style={{ minHeight: "auto" }}
                                                title=""
                                                columns={[
                                                    { title: 'Contrato', field: 'contratoIdentificacao' },
                                                    { title: 'Ponderação (%)', field: 'ponderacao' }
                                                ]}
                                                data={contratos}
                                                isLoading={false}
                                                options={{
                                                    ...table_style,
                                                    filtering: false,
                                                    paging: false,
                                                    exportButton: false
                                                }}
                                                actions={[
                                                    {
                                                        icon: 'edit',
                                                        tooltip: 'Editar Ponderação',
                                                        onClick: (event, rowData) => handleEditarPonderacao(rowData)
                                                    },
                                                    {
                                                        icon: 'delete',
                                                        tooltip: 'Remover Contrato',
                                                        onClick: (event, rowData) => handleRemoverContrato(rowData)
                                                    }
                                                ]}
                                                localization={table_translate}
                                            />
                                            <p className={somaPonderacoes === 100 || contratos.length === 0 ? "text-success" : "text-danger"}>
                                                Soma das ponderações: {somaPonderacoes}% {somaPonderacoes !== 100 && contratos.length > 0 && "— deveria somar 100%"}
                                            </p>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col lg="12" md="12" sm="12" className="text-center">
                                            <Button color="success" type="submit">
                                                <i className="fas fa-save"></i>  Salvar
                                            </Button>
                                        </Col>
                                    </Row>
                                </Form>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        </>
    );
}
